import { progress, setProgress } from "@eldrun/web-ui/ui";
import { h, mount } from "../kit/dom.ts";

export interface LoadingScreen {
  set(fraction: number, label: string): void;
}

/** Tela de carregamento com a barra de progresso do sistema visual (o valor vai pelo CSSOM, F113). */
export function showLoading(container: HTMLElement, title: string): LoadingScreen {
  const bar = progress(title, 0);
  const label = h("p", { class: "hint", id: "carregando-texto" }, "");
  mount(container, h("section", { class: "panel", "aria-label": "Carregando" }, h("h2", {}, title), bar, label));
  return {
    set(fraction, text) {
      setProgress(bar, fraction);
      label.textContent = text;
    },
  };
}
